import React, { useEffect } from "react";
import { auth } from "../firebaseConfig";
import { signOut } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from '../contexts/AuthContext';

interface SimpleUser {
  displayName: string | null;
  email: string | null;
  photoURL: string | null;
  uid: string;
}

interface LocationState {
  user: SimpleUser;
}

function LogoutPage() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const user = (location.state as LocationState)?.user;

  useEffect(() => {
    // Clear user data
    setUser(null);
    // Redirect to home page
    navigate('/');
  }, [setUser, navigate]);

  return null; // This page doesn't need to render anything
}

export default LogoutPage;
